const getContestAdId = (region, position, period) => {
  const [, periodEnd] = period.split('-');
  return region === 'north-shore'
    ? `contest_${position}_${periodEnd}`
    : `contest_regional_${position}_${periodEnd}`;
}

export default getContestAdId;
